import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

function splideMarquee() {

    console.log('Splide Marquee');

    const carousel = document.querySelectorAll('.splide--marquee');

    carousel.forEach((item) => {
        const splide = new Splide(item, {
            type: 'loop',
            arrows: false,
            pagination: false,
            drag: false,
            autoWidth: true,
            gap: 16,
            focus: 'center',
            trimSpace: false,
            clones: 10,
            speed: 15000,
            breakpoints: {
                600: {
                    gap: 12,
                }
            }
        });

        splide.mount({ AutoScroll });
    });
}

export default splideMarquee;